/**
 * **Der Vorlauf der Standard-Erinnerung** — synchronisiert über `userPreferences`, gilt für alle
 * Standard-Erinnerungen sofort (Entscheidung 6). `'off'` statt `null`, weil `usePreference`
 * ein gespeichertes `null` wie „nichts gespeichert“ behandelt und den Standard zurückgäbe.
 */
export const REMINDER_DEFAULT_OFFSET_KEY = 'reminders.defaultOffset'
export type ReminderDefaultOffset = number | 'off'
/** 30 Min. vorher, wie bei Todoist. */
export const REMINDER_DEFAULT_OFFSET: ReminderDefaultOffset = 30

/** Minuten oder `null` für „aus“ — die Form, die der Zeitplan rechnet. */
export const offsetMinutesOf = (value: ReminderDefaultOffset): number | null => (value === 'off' ? null : value)
